import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Catchysystem Technologies Pvt. Ltd.</Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                Developed & Maintenaned by <a href="https://catchcysystem.com" rel="noreferrer" target={"_blank"}>Catchysystem Technologies Pvt. Ltd.</a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
